// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-create.form-full-width .el-select,\n.form-create.form-full-width .el-cascader,\n.form-create.form-full-width .el-date-editor {\n\twidth: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
